import log from '../utils/log'
import { bind } from 'lodash'

export class BikehubStripeIdVerification {
  constructor (stripeVerificationElement) {
    this.stripe = Stripe(stripeVerificationElement.attr('stripePublishableKey'))
    this.csrf_token = $('meta[name=csrf-token]').attr('content')
    this.continueButtonEnabled = true
    this.continueButton = $('button#continue')
    this.sessionId = null
  }

  init () {
    this.continueButton.on('click', bind(this.stripeIdentity, this))
  }

  showAdBlockerNotice () {
    $('#adBlockerNotice').show()
  }

  async stripeIdentity (e) {
    e.preventDefault()
    if (this.continueButtonEnabled === false) {
      return
    } else {
      this.continueButtonEnabled = false
    }
    const ctx = this

    setTimeout(bind(this.showAdBlockerNotice, this), 6000)

    const clientSecret = await fetch('/stripe_identities.json', {
      method: 'POST',
      headers: {
        'X-CSRF-Token': ctx.csrf_token,
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin'
    })
      .then(function (response) {
        log.debug(response)
        if (response.status > 399 && response.status < 600) {
          throw new Error('error response from server')
        } else {
          return response.json()
        }
      })
      .then(function (session) {
        ctx.sessionId = session.session_id
        return session.client_secret
      })
      .catch(error => {
        log.debug('error response!', error)
        // Something probably failed in the verification - for instance, too many verification attempts
        // Redirect to account page
        window.location = '/account'
      })

    function popStripeModal (clientSecret) {
      log.debug(`Client secret: ${clientSecret}`)
      if (clientSecret) {
        ctx.stripe.verifyIdentity(clientSecret).then(function (result) {
          if (result.error) {
            log.debug(result.error)
            // To force opening the modal again, popStripeModal here
            window.stripeVerification.continueButtonEnabled = true
          } else {
            log.debug('submitting')
            window.location = `/stripe_identities/${ctx.sessionId}?submitted=true`
          }
        })
      } else {
        window.location = '/account/membership'
      }
    }
    popStripeModal(clientSecret)
  }
}
